export default "__VITE_ASSET__Bvy6$2dC__"